import * as $ from 'jquery'

$(document).ready(function () {
    $('a').click(function (e) {
        var hr = $(this).attr('href')

        if (hr === '#booking') {
            e.preventDefault()
            $('#booking-popup').fadeIn()
        }
    })

    $('#booking-popup .modal-close').click(function () {
        $('#booking-popup').fadeOut()
    })
})
